import { action } from 'satcheljs';

interface DiagnosticsActionParams {
    name: string;
    customData: { [key: string]: any };
    cId: string;
}

export const logDiagnostics = action(
    '__DIAGNOSTICS_LOG_DIAGNOSTICS',
    (action: DiagnosticsActionParams) => action
);
